<template>
    <div>
        <div class="loader" v-if="loading"></div>
        <div v-if="!loading">
            <div v-if="!model.isMultiDropdown">
                <div v-if="model.dropdownIsCity">
                    <city-dropdown-search v-model="selectedId" :disabled="details || model.isReadOnly"></city-dropdown-search>
                </div>
                <div v-else>
                    <dropdown :type="nomenclatureName"
                              :isCity="model.dropdownIsCity"
                              :fieldName="isEnVersion ? model.labelEn : model.label"
                              :disabled="details || model.isReadOnly"
                              v-model="selectedId"></dropdown>
                </div>
            </div>
            <div v-if="model.isMultiDropdown">
                <multi-select v-model="multiSelectValue"
                    :type="nomenclatureName"
                    :model="model"
                    :details="details || model.isReadOnly"
                    :fieldName="isEnVersion ? model.labelEn : model.label"></multi-select>
            </div>
        </div>
    </div>
</template>

<script>
    import Dropdown from '../dropdown/NomenclatureDropdown';
    import MultiSelect from './NomenclatureMultiSelect';
    import CityDropdownSearch from '../dropdown/CityDropdownSearch';
    import { mapGetters } from 'vuex';
    import { RegisterEventBus } from '@/buses/register-bus.js';

    export default {
        inject: ['$validator'],
        props: {
            value: [String, Number],
            model: Object,
            isNew: {
                type: Boolean,
                default: false
            },
            dropdownId: Number,
            details: {
                type: Boolean,
                default: false
            }
        },
        components: {
            Dropdown,
            MultiSelect,
            CityDropdownSearch
        },
        data() {
            return {
                nomenclatureName: '',
                selectedId: '',
                loading: true,
                multiSelectValue: ''
            }
        },
        methods: {
            init() {
                this.$http.get(`/api/Dropdown/GetNomenclatureName?nomenclatureId=${this.model.dropdownId ? this.model.dropdownId : 0}`).then(result => {
                    this.nomenclatureName = result.data;
                    this.model.fieldValue.stringValue = this.nomenclatureName;

                    if (!this.selectedId && this.model.textDefaultValue /* .intDefaultValue) */ && this.isNew) {
                        this.selectedId = this.model.textDefaultValue; // this.model.intDefaultValue;
                    }

                    this.loading = false;
                }).catch(error => {
                    this.$vs.notify({
                        title: this.$t('notifications.error'),
                        text: this.$t('notifications.errorLoadingData'),
                        color: 'danger'
                    });
                    this.loading = false;
                });
            },
            populateStringValueById(id) {
                // eslint-disable-next-line eqeqeq
                const val = this.items.filter(item => item.id == id);
                if (val && val.length > 0) {
                    this.model.fieldValue.stringValue = val[0].text;
                }
            }
        },
        watch: {
            selectedId(newVal, oldVal) {
                this.$emit('input', newVal);
                RegisterEventBus.$emit('dynamic-field-change', newVal, oldVal, this.model);
                this.model.fieldValue.intValue = newVal;
                this.model.defaultTextValue = '';
            },
            value: {
                immediate: true,
                handler(newVal, oldVal) {
                    if (this.model.isMultiDropdown) {
                        this.multiSelectValue = newVal;
                        this.model.fieldValue.textValue = newVal;
                    } else {
                        this.selectedId = newVal;
                    }
                }
            },
            multiSelectValue(newVal, oldVal) {
                this.model.fieldValue.textValue = newVal;
                this.model.defaultTextValue = '';
            }
        },
        computed: {
            ...mapGetters(['isEnVersion']),
        },
        mounted() {
            this.init();
            this.model.fieldValue.textValue = this.value;
        }
    }
</script>
